import { Component, forwardRef, OnInit, inject, output, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@core/platform/storage.service';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-language-switch',
    templateUrl: './language-switch.component.html',
    styleUrls: ['./language-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LanguageSwitchComponent),
            multi: true,
        },
    ],
    imports: [NgSelectComponent, FormsModule, NgOptionComponent]
})
export class LanguageSwitchComponent implements ControlValueAccessor, OnInit {
  private readonly translateService = inject(TranslateService);

  readonly valueName = input<string>();
  readonly selectChanged = output<any>();

  selected!: any;

  items: {
    id: string;
    language?: string;
    action: string;
  }[] = [
    {
      id: 'pl',
      language: this.translateService.instant('switch-language.polish'),
      action: 'switch-language',
    },
    {
      id: 'en',
      language: this.translateService.instant('switch-language.english'),
      action: 'switch-language',
    },
  ];

  onChange: any = (_: any) => {};
  onTouched: any = (_?: any) => {};

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  /*setDisabledState(isDisabled: boolean): void {
    this.setDisabledState(isDisabled);
  }*/

  writeValue(value: any): void {
    this.selected = value;
  }

  onSelectChange(selected: any): void {
    this.selected = selected;
    this.onChange(this.selected);
    this.onTouched();
    this.translateService.use(selected);
    this.selectChanged.emit(this.selected);
    StorageService.local.setItem('lng', this.selected);
  }

  ngOnInit() {
    if (this.items && this.items.length > 0) {
      const saved = StorageService.local.getItem('lng');

      if (saved) {
        this.selected = saved;
      } else {
        this.selected = this.items[0].id;
        this.translateService.use(this.selected);
      }

      this.onChange(this.selected);
    }
  }
}
